import React from "react";

const LJA_PATHS: Array<{ d: string; fill: string }> = [
  {
    d: "M31.8847 40C31.8847 40 31.8665 39.9812 31.8484 39.9559C31.4456 39.4303 31.061 38.9299 30.6717 38.4101C30.4123 38.06 30.1575 37.7292 29.8966 37.3779C29.75 37.182 29.6096 37.0066 29.4637 36.8116C29.275 36.5506 29.0917 36.3093 28.9031 36.0476C28.6551 35.7166 28.4124 35.406 28.1648 35.0761C28.0967 34.9598 28.0334 34.8629 27.973 34.7417C28.1434 34.37 28.3082 34.0212 28.479 33.6754C29.2605 32.0927 30.0415 30.5097 30.8272 28.9291C31.179 28.2216 31.5413 27.5193 31.9119 26.8306C31.9471 26.9551 31.9693 27.0635 31.9897 27.2002C31.9911 27.614 31.9943 27.9995 31.9843 28.4066C31.979 28.8632 31.9869 29.2984 31.9918 29.7618C31.9917 30.1756 31.9945 30.5611 31.9843 30.9683C31.979 31.4249 31.9869 31.8601 31.9918 32.3235C31.9917 32.7373 31.9945 33.1228 31.9843 33.53C31.979 33.9866 31.9869 34.4218 31.9918 34.8852C31.9917 35.2989 31.9945 35.6845 31.9843 36.0917C31.979 36.5483 31.9869 36.9835 31.9918 37.4469C31.9917 37.8607 31.9945 38.2463 31.9843 38.6534C31.975 39.1105 31.9788 39.5462 31.9579 39.9853C31.9171 39.9924 31.9009 39.9962 31.8847 40Z",
    fill: "#4A9FAD",
  },
  {
    d: "M31.8989 26.8146C31.5413 27.5193 31.179 28.2216 30.8272 28.9291C30.0415 30.5097 29.2605 32.0927 28.479 33.6754C28.3082 34.0212 28.1434 34.37 27.9456 34.7395C27.5724 34.7682 27.2294 34.7749 26.8597 34.7706C26.4257 34.7555 26.0186 34.7512 25.5834 34.7398C24.9688 34.7369 24.3823 34.7411 23.7673 34.7534C23.4861 34.7733 23.2335 34.7851 22.9527 34.7914C22.5371 34.7896 22.1497 34.7933 21.7379 34.7871C21.5924 34.7802 21.4713 34.7832 21.3462 34.7674C21.3412 34.723 21.3402 34.6974 21.3589 34.6665C21.5116 34.554 21.6446 34.447 21.7983 34.3333C22.1689 34.0565 22.5189 33.7862 22.8861 33.5114C22.9286 33.4823 22.9538 33.4578 22.9986 33.4293C23.8593 32.781 24.7004 32.1368 25.5619 31.4895C25.7764 31.3344 25.9706 31.1823 26.185 31.0239C26.4368 30.828 26.6685 30.6383 26.9223 30.4453C27.2528 30.2055 27.5612 29.9691 27.8876 29.7288C27.9773 29.6619 28.0488 29.5987 28.1424 29.5315C28.5956 29.197 29.0266 28.8664 29.4768 28.5288C29.5343 28.4844 29.5726 28.4471 29.6309 28.4063C29.9927 28.1399 30.3344 27.877 30.6965 27.6074C30.8927 27.4615 31.0687 27.3222 31.2643 27.1773C31.4779 27.0294 31.672 26.8871 31.872 26.7633C31.8849 26.7927 31.8919 26.8037 31.8989 26.8146Z",
    fill: "#385F73",
  },
  {
    d: "M31.8 0C31.8212 0.0492312 31.8256 0.106992 31.8122 0.198263C30.7484 2.3355 29.701 4.43857 28.6574 6.54348C28.4238 7.01469 28.2032 7.49237 27.9487 7.96524C27.5743 7.9716 27.2278 7.97981 26.8537 7.98123C26.3997 7.979 25.9732 7.98356 25.5187 7.98123C25.1003 7.97893 24.7099 7.98351 24.292 7.98128C23.838 7.97901 23.4115 7.98356 22.957 7.98123C22.5391 7.97903 22.1494 7.98372 21.7337 7.9815C21.5823 7.97143 21.4569 7.96827 21.3361 7.94446C21.4827 7.80389 21.6248 7.68396 21.7882 7.55703C22.1841 7.25954 22.5587 6.96905 22.9513 6.67521C23.0049 6.64007 23.0405 6.60828 23.095 6.57007C23.5225 6.24701 23.931 5.93035 24.3598 5.60723C24.488 5.51366 24.596 5.42655 24.7238 5.33467C25.0089 5.12423 25.274 4.91857 25.5594 4.70966C25.8225 4.51449 26.0654 4.32256 26.3269 4.12388C26.5259 3.97449 26.706 3.83186 26.9063 3.68366C27.3182 3.37516 27.71 3.07222 28.1019 2.76928C28.1019 2.76928 28.1045 2.77129 28.1242 2.76526C28.9908 2.1125 29.8377 1.46577 30.7057 0.811276C30.9329 0.629812 31.139 0.456108 31.3452 0.282404C31.4912 0.191113 31.6371 0.099821 31.8 0Z",
    fill: "#385F73",
  },
  {
    d: "M27.9766 7.96709C28.2032 7.49238 28.4238 7.01469 28.6574 6.54348C29.701 4.43857 30.7484 2.33551 31.8123 0.220186C31.8595 0.225416 31.8888 0.242245 31.9341 0.265157C31.9518 0.678557 31.9536 1.08587 31.934 1.53916C31.925 2.00106 31.9375 2.41699 31.9499 2.83291C31.9517 3.24024 31.9535 3.64757 31.9347 4.09954C31.9353 4.31785 31.9565 4.49153 31.9778 4.6652C31.9842 4.86938 31.9905 5.07356 32.0015 5.30543C32.0021 5.76133 31.9981 6.18954 31.9995 6.64587C32.0022 7.06208 31.9995 7.45016 32.0015 7.86653C32.0021 8.32303 31.9981 8.75124 31.9995 9.20758C32.0022 9.62378 31.9995 10.0119 32.0015 10.4282C32.0021 10.8847 31.9981 11.3129 31.9995 11.7693C32.002 12.1857 31.9992 12.574 32 12.9907C31.9964 13.045 31.989 13.0708 31.9585 13.1181C31.9146 13.1449 31.8939 13.1501 31.8745 13.1546C31.8756 13.154 31.8754 13.1517 31.8773 13.1311C31.8416 13.0794 31.8041 13.0482 31.7547 13.015C31.7428 13.0129 31.7189 13.0102 31.7128 12.9898C31.1342 12.1968 30.5617 11.4241 29.9898 10.6312C29.9544 10.5786 29.9184 10.5462 29.8657 10.5022C29.5234 10.0703 29.1979 9.65005 28.8653 9.2085C28.6263 8.88075 28.3943 8.57431 28.1567 8.24886C28.0929 8.14226 28.0347 8.05468 27.9766 7.96709Z",
    fill: "#479EAD",
  },
  {
    d: "M31.8316 26.4947C31.6594 26.2786 31.4872 26.0625 31.2914 25.8155C31.0702 25.529 30.8726 25.2735 30.6696 24.9987C30.5647 24.8544 30.4652 24.7295 30.3587 24.5849C30.0758 24.2107 29.8 23.8561 29.5206 23.485C29.5112 23.4468 29.5053 23.4252 29.5007 23.3827C29.4655 23.3286 29.4289 23.2953 29.3801 23.2598C29.368 23.2577 29.3434 23.2542 29.3378 23.2337C29.0007 22.7647 28.6669 22.318 28.3385 21.8673C28.1553 21.6158 27.9917 21.3429 27.6392 21.3429C27.7924 21.268 27.9984 21.2435 28.0525 21.1398C28.585 20.1184 29.0932 19.0844 29.6063 18.0529C30.3504 16.5569 31.0929 15.06 31.8499 13.5712C31.8907 13.5952 31.9176 13.6115 31.9445 13.6277C31.9469 13.8532 31.9492 14.0786 31.9311 14.3499C31.9237 14.811 31.9368 15.2262 31.9499 15.6414C31.9517 16.0487 31.9535 16.4561 31.9339 16.9094C31.904 17.1842 31.8837 17.4136 31.8912 17.642C31.8954 17.7697 31.9457 17.8959 31.9753 18.0228C31.982 18.0492 31.9887 18.0756 32.0006 18.1218C32.0019 18.5699 31.998 18.998 31.9994 19.4544C32.0021 19.8706 31.9994 20.2587 32.0014 20.675C32.0021 21.1315 31.998 21.5597 31.9994 22.0161C32.0021 22.4323 31.9994 22.8204 32.0014 23.2367C32.0021 23.6932 31.9981 24.1214 31.9994 24.5778C32.002 24.9942 31.9991 25.3825 32 25.7993C31.9965 26.0311 31.9893 26.2344 31.9582 26.4661C31.9001 26.4945 31.8658 26.4946 31.8316 26.4947Z",
    fill: "#479EAD",
  },
  {
    d: "M2.48959 24.1417C2.36535 24.1375 2.24111 24.1333 2.09068 24.1344C1.46318 24.1356 0.86184 24.1342 0.260634 24.1244C0.172518 24.123 0.0850516 24.0816 0 24.0334C0.280306 23.8007 0.557898 23.5935 0.845339 23.3694C0.995353 23.2502 1.13552 23.1477 1.3008 23.0227C2.15969 22.3698 2.99347 21.7395 3.846 21.1038C4.02387 20.97 4.18298 20.8417 4.36166 20.7083C4.60749 20.527 4.83375 20.3508 5.0802 20.1678C5.37991 19.9418 5.65943 19.7224 5.95781 19.4968C6.11405 19.3836 6.25144 19.2767 6.40862 19.1648C7.69961 18.1917 8.97081 17.2235 10.2606 16.2509C10.3241 16.224 10.3691 16.2015 10.4166 16.2026C10.3809 16.3298 10.3511 16.4375 10.3027 16.5361C10.0528 17.0455 9.7969 17.5519 9.54523 18.0605C8.77645 19.6138 8.00748 21.1671 7.24119 22.7216C7.01274 23.1851 6.79287 23.6528 6.54595 24.1183C6.477 24.1238 6.43118 24.1295 6.35741 24.1315C5.90364 24.1324 5.47784 24.137 5.02391 24.1354C4.60621 24.1334 4.21665 24.1375 3.79934 24.1353C3.34426 24.1332 2.91693 24.1375 2.48959 24.1417Z",
    fill: "#395F73",
  },
  {
    d: "M21.2725 32.2919C21.2696 32.6794 21.2667 33.067 21.2679 33.4829C21.27 33.8795 21.2679 34.2477 21.2755 34.6432C21.205 34.6213 21.105 34.5886 21.0484 34.52C20.8649 34.2979 20.6973 34.0626 20.5 33.802C20.3842 33.6549 20.2919 33.5383 20.1917 33.4032C19.8564 32.9576 19.5292 32.5303 19.1963 32.0832C18.9084 31.6925 18.6261 31.3217 18.3375 30.9312C18.1767 30.7155 18.0222 30.5195 17.8618 30.3041C17.7137 30.0998 17.5715 29.915 17.4231 29.7117C17.3595 29.6072 17.3019 29.5213 17.2512 29.4139C17.5187 28.8562 17.7751 28.3179 18.0404 27.784C19.0585 25.7345 20.0799 23.6866 21.0963 21.6363C21.1159 21.5967 21.0885 21.5339 21.0946 21.4629C21.115 21.3617 21.1239 21.2797 21.1635 21.1929C21.2146 21.1849 21.2351 21.1816 21.2629 21.1948C21.3118 21.2312 21.3533 21.251 21.3966 21.2876C21.396 21.3266 21.3935 21.349 21.3723 21.387C21.3269 21.6168 21.3001 21.8308 21.269 22.0732C21.2675 22.4892 21.2704 22.8769 21.2683 23.2929C21.2667 23.7496 21.27 24.1781 21.269 24.6349C21.2675 25.0509 21.2704 25.4386 21.2683 25.8546C21.2667 26.3113 21.27 26.7398 21.269 27.1966C21.2675 27.6126 21.2704 28.0003 21.2683 28.4163C21.2667 28.873 21.27 29.3015 21.269 29.7583C21.2675 30.1743 21.2704 30.562 21.2683 30.978C21.2664 31.4348 21.2695 31.8633 21.2725 32.2919Z",
    fill: "#4CA0AF",
  },
  {
    d: "M21.391 21.3713C21.3935 21.3489 21.396 21.3266 21.4127 21.273C21.5648 21.126 21.7027 21.0103 21.8596 20.891C21.9487 20.8293 22.0187 20.7711 22.1084 20.7078C22.412 20.4765 22.6959 20.2504 23.001 20.026C23.2443 19.853 23.4666 19.6783 23.7081 19.4979C23.9248 19.3387 24.1223 19.1851 24.3388 19.0273C24.7343 18.7299 25.1106 18.4367 25.5011 18.141C25.5345 18.1304 25.546 18.1161 25.5704 18.0902C26.4487 17.4315 27.3065 16.7781 28.1842 16.1189C28.4297 15.9339 28.6554 15.7547 28.9018 15.5708C29.0969 15.4271 29.2713 15.288 29.4662 15.1455C29.8197 14.8815 30.1525 14.6209 30.5041 14.356C30.5701 14.3106 30.6175 14.2696 30.6649 14.2286C31.037 13.9651 31.409 13.7016 31.8019 13.4318C31.8259 13.4562 31.8289 13.4868 31.834 13.5405C31.0929 15.06 30.3504 16.5569 29.6063 18.0529C29.0932 19.0844 28.585 20.1184 28.0525 21.1398C27.9984 21.2435 27.7924 21.2679 27.6108 21.3473C27.3375 21.3735 27.1103 21.3816 26.8557 21.3813C26.4006 21.3787 25.9728 21.3844 25.5174 21.382C25.1002 21.3793 24.7107 21.3847 24.294 21.3816C23.8391 21.3778 23.4116 21.3824 22.9563 21.3788C22.5378 21.3813 22.1471 21.392 21.7312 21.3955C21.6011 21.3827 21.496 21.377 21.391 21.3713Z",
    fill: "#385F73",
  },
  {
    d: "M6.56908 24.1185C6.79288 23.6528 7.01274 23.1851 7.24119 22.7216C8.00748 21.1671 8.77645 19.6138 9.54523 18.0605C9.7969 17.5519 10.0528 17.0455 10.3027 16.5361C10.3511 16.4375 10.3809 16.3298 10.4182 16.2055C10.4171 16.1847 10.4122 16.189 10.4267 16.1823C10.4535 16.1584 10.4658 16.1411 10.4733 16.1149C10.4684 16.106 10.4687 16.0857 10.4979 16.0951C10.5458 16.1124 10.5646 16.1203 10.5739 16.1549C10.5682 16.4257 10.572 16.6698 10.5668 16.9419C10.5638 17.3629 10.5698 17.7559 10.5687 18.176C10.5663 18.6273 10.5711 19.0514 10.5668 19.5036C10.5638 19.9246 10.5698 20.3176 10.5687 20.7377C10.5663 21.189 10.571 21.6131 10.5667 22.0653C10.5637 22.4863 10.5698 22.8793 10.5687 23.2994C10.5663 23.7507 10.5711 24.1749 10.5668 24.627C10.5638 25.048 10.5698 25.441 10.5687 25.8611C10.5663 26.3124 10.571 26.7365 10.5667 27.1887C10.5633 27.6094 10.5689 28.002 10.5675 28.4218C10.5644 28.7319 10.5684 29.015 10.5585 29.3144C10.5211 29.3454 10.4976 29.3601 10.4661 29.3557C10.3649 29.2318 10.2718 29.127 10.1775 29.0024C10.0216 28.7824 9.86681 28.5821 9.70532 28.3608C9.47499 28.0478 9.25135 27.7558 9.02261 27.4436C8.94691 27.3377 8.87632 27.2519 8.80196 27.1472C8.40575 26.623 8.0133 26.1177 7.6178 25.5924C7.37137 25.2489 7.12799 24.9252 6.88084 24.5809C6.7744 24.4131 6.67174 24.2658 6.56908 24.1185Z",
    fill: "#489EAD",
  },
  {
    d: "M10.6685 15.9381C10.7833 15.8557 10.8981 15.7733 11.0447 15.6685C11.2241 15.5273 11.3717 15.4086 11.5399 15.2841C11.8939 15.02 12.2274 14.7616 12.5804 14.4977C12.6721 14.4323 12.7441 14.3723 12.8358 14.3066C13.2657 13.9827 13.6761 13.6647 14.1068 13.3401C14.246 13.2349 14.3649 13.1361 14.5032 13.0334C14.7833 12.8278 15.044 12.6261 15.3254 12.4195C15.603 12.2137 15.8599 12.013 16.1361 11.8065C16.3157 11.6737 16.476 11.5467 16.6559 11.4145C17.2881 10.9465 17.9024 10.4857 18.5132 10.0202C19.155 9.53101 19.7934 9.03737 20.4542 8.53896C20.6592 8.39558 20.8433 8.25891 21.0274 8.12224C21.0384 8.12595 21.0494 8.12965 21.0778 8.15771C21.0932 8.22819 21.0911 8.27431 21.0725 8.33319C20.2877 9.89618 19.5188 11.4461 18.7515 12.9968C18.2485 14.0132 17.7479 15.0308 17.2189 16.0494C17.0072 16.0556 16.8229 16.0602 16.6105 16.0587C16.1537 16.0567 15.7248 16.061 15.2684 16.0593C15.0153 16.0582 14.7898 16.0629 14.5413 16.0596C13.3519 16.0493 12.1855 16.0501 11.0191 16.0402C10.902 16.0392 10.7854 15.9737 10.6685 15.9381Z",
    fill: "#385F73",
  },
  {
    d: "M21.0831 21.482C21.0885 21.5339 21.1159 21.5967 21.0963 21.6363C20.0799 23.6866 19.0585 25.7345 18.0404 27.784C17.7751 28.3179 17.5187 28.8562 17.2237 29.4128C17.0041 29.441 16.8191 29.4489 16.6074 29.4486C16.1523 29.4535 15.7238 29.4665 15.2674 29.4734C14.8521 29.4712 14.4648 29.4752 14.0495 29.4724C13.5933 29.4692 13.1652 29.4728 12.7144 29.4662C12.299 29.4629 11.9062 29.4697 11.4858 29.4708C11.1999 29.468 10.9416 29.471 10.6738 29.4549C10.6706 29.3956 10.6769 29.3552 10.7028 29.309C10.9858 29.0982 11.2493 28.8933 11.5323 28.6825C11.6555 28.5882 11.7593 28.4999 11.883 28.4076C12.1855 28.1855 12.4682 27.9672 12.7714 27.7423C13.0268 27.5517 13.2615 27.3677 13.5156 27.1782C13.7158 27.0296 13.8966 26.8866 14.0976 26.738C14.5006 26.4349 14.8836 26.1374 15.2762 25.8393C15.2858 25.8388 15.2956 25.8221 15.3156 25.8172C16.1772 25.169 17.0188 24.5257 17.881 23.8778C18.1575 23.6722 18.4134 23.471 18.6892 23.2663C18.8922 23.1188 19.0752 22.9749 19.2778 22.8248C19.5717 22.6058 19.8459 22.393 20.1404 22.1753C20.2774 22.0739 20.3943 21.9773 20.5305 21.8746C20.7275 21.7396 20.9053 21.6108 21.0831 21.482Z",
    fill: "#395F73",
  },
  {
    d: "M21.0725 8.33319C21.1099 8.4357 21.1488 8.55098 21.1489 8.66628C21.1522 11.8464 21.151 15.0264 21.1539 18.2065C21.1541 18.322 21.1892 18.4374 21.2366 18.5885C21.2701 18.9102 21.2749 19.1962 21.2753 19.5105C21.2736 19.9271 21.2761 20.3153 21.2743 20.7271C21.2651 20.8932 21.2603 21.0358 21.2555 21.1783C21.2351 21.1816 21.2146 21.1849 21.1469 21.1825C20.9747 21.0154 20.8499 20.8539 20.7248 20.6712C20.6652 20.5856 20.6058 20.5213 20.5443 20.4576C20.5422 20.4582 20.5441 20.4542 20.5433 20.4338C20.5058 20.3676 20.469 20.3218 20.4164 20.2622C20.1934 19.9876 19.9861 19.7268 19.772 19.4457C19.5769 19.1801 19.3887 18.9347 19.1932 18.67C19.0514 18.4794 18.9168 18.3081 18.7765 18.1166C18.4725 17.7138 18.1741 17.3312 17.875 16.9402C17.8744 16.9318 17.8619 16.9206 17.8582 16.8999C17.6517 16.6021 17.449 16.325 17.2463 16.0479C17.7479 15.0308 18.2485 14.0132 18.7515 12.9968C19.5188 11.4461 20.2877 9.89618 21.0725 8.33319Z",
    fill: "#479EAD",
  },
];

/** Dark blue path fills in LJA logo; when primaryColor/secondaryColor are passed, these use secondaryColor. */
const LJA_SECONDARY_FILLS = new Set(["#385F73", "#395F73"]);

export const LJAlogo = (
  props: React.SVGProps<SVGSVGElement> & {
    width?: number | string;
    height?: number | string;
    primaryColor?: string;
    secondaryColor?: string;
  },
) => {
  const {
    width = "1.25rem",
    height = "1.5625rem",
    primaryColor,
    secondaryColor,
    ...svgProps
  } = props;

  const resolveFill = (defaultFill: string): string => {
    if (primaryColor != null && secondaryColor != null) {
      return LJA_SECONDARY_FILLS.has(defaultFill)
        ? secondaryColor
        : primaryColor;
    }
    if (primaryColor != null && !LJA_SECONDARY_FILLS.has(defaultFill))
      return primaryColor;
    if (secondaryColor != null && LJA_SECONDARY_FILLS.has(defaultFill))
      return secondaryColor;
    return defaultFill;
  };

  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 32 40",
      fill: "none",
      style: {
        width: width,
        height: height,
        display: "block",
        margin: "0 0.4rem 0 0",
        padding: 0,
        verticalAlign: "middle",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    ...LJA_PATHS.map(({ d, fill }, i) =>
      React.createElement("path", {
        key: i,
        d,
        fill: resolveFill(fill),
      }),
    ),
  );
};

export const HomeIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    fill?: string;
    width?: number | string;
    height?: number | string;
  },
) => {
  const {
    fill = "#00C0CA",
    width = "1rem",
    height = "1rem",
    ...svgProps
  } = props;
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 25 24",
      fill: "none",
      style: {
        width: width,
        height: height,
        display: "block",
        margin: 0,
        padding: 0,
        verticalAlign: "middle",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      d: "M13.0196 0.40082C12.443 -0.133607 11.5523 -0.133607 10.9804 0.40082L0.479334 10.1518C0.0292903 10.5737 -0.120724 11.2253 0.104298 11.7972C0.32932 12.3692 0.877811 12.7489 1.49662 12.7489H2.24669V20.9997C2.24669 22.6546 3.59214 24 5.24699 24H18.7483C20.4032 24 21.7486 22.6546 21.7486 20.9997V12.7489H22.4987C23.1175 12.7489 23.6707 12.3692 23.8957 11.7972C24.1207 11.2253 23.9707 10.569 23.5206 10.1518L13.0196 0.40082ZM11.2476 14.9991H12.7477C13.99 14.9991 14.9979 16.007 14.9979 17.2493V21.7498H8.99735V17.2493C8.99735 16.007 10.0053 14.9991 11.2476 14.9991Z",
      fill: fill,
    }),
  );
};

export const LeaderboardIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    fill?: string;
    width?: number | string;
    height?: number | string;
  },
) => {
  const {
    fill = "#00C0CA",
    width = "1rem",
    height = "1rem",
    ...svgProps
  } = props;
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 25 24",
      fill: "none",
      style: {
        width: width,
        height: height,
        display: "block",
        margin: 0,
        padding: 0,
        verticalAlign: "middle",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      d: "M7.25074 0.00468658H17.7487C18.9906 0.00468658 20.0029 1.02636 19.9561 2.26362C19.9467 2.51201 19.9373 2.7604 19.9233 3.0041H22.2478C23.471 3.0041 24.5489 4.0164 24.4552 5.33802C24.1037 10.198 21.6198 12.8694 18.925 14.266C18.1845 14.6503 17.43 14.9361 16.713 15.147C15.7663 16.4874 14.7821 17.1951 13.9994 17.5747V21.0006H16.9988C17.8284 21.0006 18.4985 21.6708 18.4985 22.5003C18.4985 23.3298 17.8284 24 16.9988 24H8.00059C7.17107 24 6.50089 23.3298 6.50089 22.5003C6.50089 21.6708 7.17107 21.0006 8.00059 21.0006H11V17.5747C10.2502 17.2138 9.31752 16.5436 8.40833 15.3111C7.54599 15.0861 6.60868 14.744 5.69479 14.2285C3.15935 12.8084 0.872298 10.1324 0.544237 5.32865C0.455192 4.01172 1.52842 2.99941 2.75162 2.99941H5.07616C5.06211 2.75571 5.05273 2.51201 5.04336 2.25893C4.99649 1.01699 6.0088 0 7.25074 0V0.00468658ZM5.24488 5.25366H2.78911C3.07968 9.2232 4.90276 11.2103 6.78208 12.2648C6.10721 10.5167 5.54951 8.23433 5.24488 5.25366ZM18.297 12.0398C20.1951 10.9244 21.9104 8.942 22.2009 5.25366H19.7499C19.4593 8.10779 18.9344 10.3245 18.297 12.0398Z",
      fill: fill,
    }),
  );
};

export const GamesIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    fill?: string;
    width?: number | string;
    height?: number | string;
  },
) => {
  const {
    fill = "#00C0CA",
    width = "1rem",
    height = "1rem",
    ...svgProps
  } = props;
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 24 24",
      fill: "none",
      style: {
        width: width,
        height: height,
        display: "block",
        margin: 0,
        padding: 0,
        verticalAlign: "middle",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 2H17C19.7614 2 22 4.23858 22 7V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7C2 4.23858 4.23858 2 7 2ZM8.25 6.25C9.2165 6.25 10 7.0335 10 8C10 8.9665 9.2165 9.75 8.25 9.75C7.2835 9.75 6.5 8.9665 6.5 8C6.5 7.0335 7.2835 6.25 8.25 6.25ZM17.5 8C17.5 7.0335 16.7165 6.25 15.75 6.25C14.7835 6.25 14 7.0335 14 8C14 8.9665 14.7835 9.75 15.75 9.75C16.7165 9.75 17.5 8.9665 17.5 8ZM12 10.25C12.9665 10.25 13.75 11.0335 13.75 12C13.75 12.9665 12.9665 13.75 12 13.75C11.0335 13.75 10.25 12.9665 10.25 12C10.25 11.0335 11.0335 10.25 12 10.25ZM10 16C10 15.0335 9.2165 14.25 8.25 14.25C7.2835 14.25 6.5 15.0335 6.5 16C6.5 16.9665 7.2835 17.75 8.25 17.75C9.2165 17.75 10 16.9665 10 16ZM15.75 14.25C16.7165 14.25 17.5 15.0335 17.5 16C17.5 16.9665 16.7165 17.75 15.75 17.75C14.7835 17.75 14 16.9665 14 16C14 15.0335 14.7835 14.25 15.75 14.25Z",
      fill: fill,
    }),
  );
};

export const ProfileIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    fill?: string;
    width?: number | string;
    height?: number | string;
  },
) => {
  const {
    fill = "#00C0CA",
    width = "1rem",
    height = "1rem",
    ...svgProps
  } = props;
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 25 24",
      fill: "none",
      style: {
        width: width,
        height: height,
        display: "block",
        margin: 0,
        padding: 0,
        verticalAlign: "middle",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      d: "M11 11.4286C11.7728 11.4286 12.538 11.2808 13.2519 10.9936C13.9659 10.7064 14.6146 10.2855 15.161 9.7549C15.7075 9.22428 16.1409 8.59434 16.4367 7.90105C16.7324 7.20776 16.8846 6.4647 16.8846 5.71429C16.8846 4.96388 16.7324 4.22081 16.4367 3.52752C16.1409 2.83423 15.7075 2.2043 15.161 1.67368C14.6146 1.14306 13.9659 0.722144 13.2519 0.434974C12.538 0.147804 11.7728 -1.1182e-08 11 0C10.2272 -1.1182e-08 9.462 0.147804 8.74804 0.434974C8.03409 0.722144 7.38537 1.14306 6.83894 1.67368C6.2925 2.2043 5.85904 2.83423 5.56331 3.52752C5.26758 4.22081 5.11537 4.96388 5.11537 5.71429C5.11537 6.4647 5.26758 7.20776 5.56331 7.90105C5.85904 8.59434 6.2925 9.22428 6.83894 9.7549C7.38537 10.2855 8.03409 10.7064 8.74804 10.9936C9.462 11.2808 10.2272 11.4286 11 11.4286ZM9.54355 14.0952C4.71326 14.0952 0.799988 17.8952 0.799988 22.5857C0.799988 23.3667 1.4522 24 2.25643 24H19.7435C20.5478 24 21.2 23.3667 21.2 22.5857C21.2 17.8952 17.2867 14.0952 12.4564 14.0952H9.54355Z",
      fill: fill,
      transform: "translate(1.5 0)",
    }),
  );
};

export const ShoppingCartIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    fill?: string;
    width?: number | string;
    height?: number | string;
  },
) => {
  const {
    fill = "#00C0CA",
    width = "1rem",
    height = "1rem",
    ...svgProps
  } = props;
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0.9 0 27.2 24",
      fill: "none",
      style: {
        width: width,
        height: height,
        display: "block",
        margin: 0,
        padding: 0,
        verticalAlign: "middle",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      d: "M14.5 0C14.83 0 15.145 0.135 15.37 0.375L22.57 7.975L22.595 8H26.5C27.385 8 28.1 8.715 28.1 9.6C28.1 10.325 27.62 10.935 26.96 11.135L24.655 21.495C24.33 22.96 23.03 24 21.53 24H7.46502C5.96502 24 4.66502 22.96 4.34002 21.495L2.04002 11.135C1.38002 10.94 0.900024 10.325 0.900024 9.6C0.900024 8.715 1.61502 8 2.50002 8H6.40502L6.43002 7.975L13.63 0.375C13.855 0.135 14.17 0 14.5 0ZM14.5 2.945L9.71002 8H19.29L14.5 2.945ZM10.5 13.2C10.5 12.535 9.96502 12 9.30002 12C8.63502 12 8.10002 12.535 8.10002 13.2V18.8C8.10002 19.465 8.63502 20 9.30002 20C9.96502 20 10.5 19.465 10.5 18.8V13.2ZM14.5 12C13.835 12 13.3 12.535 13.3 13.2V18.8C13.3 19.465 13.835 20 14.5 20C15.165 20 15.7 19.465 15.7 18.8V13.2C15.7 12.535 15.165 12 14.5 12ZM20.9 13.2C20.9 12.535 20.365 12 19.7 12C19.035 12 18.5 12.535 18.5 13.2V18.8C18.5 19.465 19.035 20 19.7 20C20.365 20 20.9 19.465 20.9 18.8V13.2Z",
      fill: fill,
    }),
  );
};

export const SettingsIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    fill?: string;
    width?: number | string;
    height?: number | string;
  },
) => {
  const {
    fill = "#00C0CA",
    width = "1rem",
    height = "1rem",
    ...svgProps
  } = props;
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 24 24",
      fill: "none",
      style: {
        width: width,
        height: height,
        display: "block",
        margin: 0,
        padding: 0,
        verticalAlign: "middle",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      d: "M9.23676 1.125C9.37215 0.472059 9.96336 0 10.6493 0H13.3481C14.0341 0 14.6253 0.472059 14.7607 1.125L15.4151 4.21324C16.0514 4.47794 16.6471 4.81765 17.1887 5.21912L20.2485 4.22647C20.8984 4.01471 21.6115 4.27941 21.9545 4.86176L23.3039 7.14706C23.6469 7.72941 23.525 8.46176 23.0105 8.90735L20.6051 10.9985C20.6457 11.325 20.6637 11.6603 20.6637 12C20.6637 12.3397 20.6412 12.675 20.6051 13.0015L23.015 15.0971C23.5295 15.5426 23.6469 16.2794 23.3084 16.8574L21.959 19.1426C21.616 19.7206 20.9029 19.9897 20.2531 19.7779L17.1932 18.7853C16.6471 19.1868 16.0514 19.5221 15.4196 19.7912L14.7697 22.875C14.6298 23.5324 14.0386 24 13.3572 24H10.6584C9.97238 24 9.38118 23.5279 9.24579 22.875L8.59591 19.7912C7.95957 19.5265 7.36837 19.1868 6.82229 18.7853L3.74892 19.7779C3.09904 19.9897 2.38599 19.725 2.043 19.1426L0.693601 16.8574C0.350611 16.275 0.472463 15.5426 0.986948 15.0971L3.3969 13.0015C3.35629 12.675 3.33823 12.3397 3.33823 12C3.33823 11.6603 3.3608 11.325 3.3969 10.9985L0.986948 8.90294C0.472463 8.45735 0.355124 7.72059 0.693601 7.14265L2.043 4.85735C2.38599 4.275 3.09904 4.01029 3.74892 4.22206L6.80875 5.21471C7.35483 4.81324 7.95055 4.47794 8.58237 4.20882L9.23676 1.125ZM11.9987 15.5294C12.4729 15.5277 12.942 15.4347 13.3793 15.2557C13.8167 15.0767 14.2137 14.8153 14.5477 14.4863C14.8817 14.1573 15.1462 13.7673 15.326 13.3384C15.5058 12.9095 15.5974 12.4503 15.5956 11.9868C15.5938 11.5233 15.4987 11.0647 15.3156 10.6371C15.1325 10.2096 14.8651 9.82148 14.5286 9.49497C14.1921 9.16846 13.793 8.90995 13.3543 8.73418C12.9156 8.55842 12.4458 8.46885 11.9717 8.47059C11.4975 8.47233 11.0284 8.56534 10.591 8.74431C10.1537 8.92329 9.75667 9.18472 9.42267 9.51369C9.08867 9.84265 8.82422 10.2327 8.64442 10.6616C8.46462 11.0905 8.37299 11.5497 8.37477 12.0132C8.37655 12.4767 8.4717 12.9353 8.65478 13.3629C8.83786 13.7904 9.1053 14.1785 9.44181 14.505C9.77833 14.8315 10.1773 15.0901 10.6161 15.2658C11.0548 15.4416 11.5246 15.5311 11.9987 15.5294Z",
      fill: fill,
    }),
  );
};

export const LogoutIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    fill?: string;
    width?: number | string;
    height?: number | string;
  },
) => {
  const {
    fill = "#00C0CA",
    width = "1rem",
    height = "1rem",
    ...svgProps
  } = props;
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 24 20",
      fill: "none",
      style: {
        width: width,
        height: height,
        display: "block",
        margin: 0,
        padding: 0,
        verticalAlign: "middle",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      d: "M7.71488 2.85714C8.50506 2.85714 9.14345 2.21875 9.14345 1.42857C9.14345 0.638393 8.50506 0 7.71488 0H4.85774C2.49166 0 0.572021 1.91964 0.572021 4.28571V15.7143C0.572021 18.0804 2.49166 20 4.85774 20H7.71488C8.50506 20 9.14345 19.3616 9.14345 18.5714C9.14345 17.7813 8.50506 17.1429 7.71488 17.1429H4.85774C4.06756 17.1429 3.42916 16.5045 3.42916 15.7143V4.28571C3.42916 3.49554 4.06756 2.85714 4.85774 2.85714H7.71488ZM23.0095 11.0089C23.5676 10.4509 23.5676 9.54464 23.0095 8.98661L17.2952 3.27232C16.7372 2.71429 15.8309 2.71429 15.2729 3.27232C14.7149 3.83036 14.7149 4.73661 15.2729 5.29464L18.5497 8.57143H9.14345C8.35327 8.57143 7.71488 9.20982 7.71488 10C7.71488 10.7902 8.35327 11.4286 9.14345 11.4286H18.5497L15.2729 14.7054C14.7149 15.2634 14.7149 16.1696 15.2729 16.7277C15.8309 17.2857 16.7372 17.2857 17.2952 16.7277L23.0095 11.0134V11.0089Z",
      fill: fill,
    }),
  );
};

export const EditIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    fill?: string;
    width?: number | string;
    height?: number | string;
  },
) => {
  const {
    fill = "#00C0CA",
    width = "1rem",
    height = "1rem",
    ...svgProps
  } = props;
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 16 16",
      fill: "none",
      style: {
        width: width,
        height: height,
        display: "block",
        margin: 0,
        padding: 0,
        verticalAlign: "middle",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      d: "M11.0273 0.6625L9.62418 2.06562L13.9336 6.375L15.3367 4.97188C15.7617 4.55 15.9992 3.975 15.9992 3.375C15.9992 2.775 15.7617 2.2 15.3367 1.77813L14.2211 0.6625C13.7992 0.2375 13.2242 0 12.6242 0C12.0242 0 11.4492 0.2375 11.0273 0.6625ZM8.5648 3.125L1.83981 9.84688C1.50543 10.1813 1.26168 10.6 1.13355 11.0562L0.0273051 15.05C-0.0445699 15.3094 0.0273051 15.5906 0.221055 15.7812C0.414805 15.9719 0.69293 16.0469 0.952305 15.975L4.94605 14.8656C5.4023 14.7375 5.81793 14.4969 6.15543 14.1594L12.8742 7.43437L8.5648 3.125Z",
      fill: fill,
    }),
  );
};

export const DownloadIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    fill?: string;
    width?: number | string;
    height?: number | string;
  },
) => {
  const {
    fill = "#00C0CA",
    width = "1rem",
    height = "1rem",
    ...svgProps
  } = props;
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 18 19",
      fill: "none",
      style: {
        width: width,
        height: height,
        display: "block",
        margin: 0,
        padding: 0,
        verticalAlign: "middle",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      d: "M10.1333 1.26667C10.1333 0.566042 9.56729 0 8.86667 0C8.16604 0 7.6 0.566042 7.6 1.26667V9.60687L5.96125 7.96812C5.46646 7.47333 4.66292 7.47333 4.16813 7.96812C3.67333 8.46292 3.67333 9.26646 4.16813 9.76125L7.96812 13.5612C8.46292 14.056 9.26646 14.056 9.76125 13.5612L13.5612 9.76125C14.056 9.26646 14.056 8.46292 13.5612 7.96812C13.0665 7.47333 12.2629 7.47333 11.7681 7.96812L10.1333 9.60687V1.26667ZM2.53333 12.6667C1.13604 12.6667 0 13.8027 0 15.2V16.4667C0 17.864 1.13604 19 2.53333 19H15.2C16.5973 19 17.7333 17.864 17.7333 16.4667V15.2C17.7333 13.8027 16.5973 12.6667 15.2 12.6667H13.3435L11.1031 14.9071C9.86812 16.1421 7.86125 16.1421 6.62625 14.9071L4.38979 12.6667H2.53333ZM14.5667 14.8833C14.6914 14.8833 14.815 14.9079 14.9302 14.9556C15.0455 15.0034 15.1502 15.0734 15.2384 15.1616C15.3266 15.2498 15.3966 15.3545 15.4444 15.4698C15.4921 15.585 15.5167 15.7086 15.5167 15.8333C15.5167 15.9581 15.4921 16.0816 15.4444 16.1969C15.3966 16.3121 15.3266 16.4169 15.2384 16.5051C15.1502 16.5933 15.0455 16.6633 14.9302 16.711C14.815 16.7588 14.6914 16.7833 14.5667 16.7833C14.4419 16.7833 14.3184 16.7588 14.2031 16.711C14.0879 16.6633 13.9831 16.5933 13.8949 16.5051C13.8067 16.4169 13.7367 16.3121 13.689 16.1969C13.6412 16.0816 13.6167 15.9581 13.6167 15.8333C13.6167 15.7086 13.6412 15.585 13.689 15.4698C13.7367 15.3545 13.8067 15.2498 13.8949 15.1616C13.9831 15.0734 14.0879 15.0034 14.2031 14.9556C14.3184 14.9079 14.4419 14.8833 14.5667 14.8833Z",
      fill: fill,
    }),
  );
};
